import React from 'react';
import { useNavigate } from 'react-router-dom';

const InviteErrorPage = ({ lang, theme, translations }) => {
  const navigate = useNavigate();

  const themeVars = theme === "dark"
    ? {
        bg: "#1a1a2e",
        fg: "#ffffff",
        card: "#16213e",
        border: "#667eea",
        btnBg: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        btnFg: "#ffffff",
        error: "#ff4757"
      }
    : {
        bg: "#ffffff",
        fg: "#333333",
        card: "#ffffff",
        border: "#667eea",
        btnBg: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        btnFg: "#ffffff",
        error: "#ff4757"
      };

  return (
    <div style={{
      minHeight: "100vh",
      background: themeVars.bg,
      color: themeVars.fg,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Inter, Arial, sans-serif",
      padding: "20px"
    }}>
      <div style={{
        background: themeVars.card,
        padding: "60px 40px",
        borderRadius: "24px",
        textAlign: "center",
        maxWidth: "600px",
        width: "100%",
        border: `1px solid ${themeVars.error}33`,
        boxShadow: "0 20px 60px rgba(0,0,0,0.1)"
      }}>
        {/* Error Icon */}
        <div style={{
          fontSize: "120px",
          marginBottom: "24px",
          filter: "drop-shadow(0 4px 8px rgba(255, 71, 87, 0.3))"
        }}>
          🚫
        </div>

        {/* Error Title */}
        <h1 style={{
          fontSize: "32px",
          fontWeight: 800,
          marginBottom: "16px",
          color: themeVars.error,
          letterSpacing: "-0.5px"
        }}>
          {lang === "en" ? "Access Denied" : 
           lang === "fr" ? "Accès refusé" : 
           "Доступ запрещен"}
        </h1>

        {/* Error Message */}
        <p style={{
          fontSize: "18px",
          opacity: 0.9,
          marginBottom: "32px",
          lineHeight: 1.6,
          color: themeVars.fg
        }}>
          {lang === "en" ? 
            "You need a valid invitation to access this platform. Please contact an existing member to get an invitation code." :
           lang === "fr" ? 
            "Vous avez besoin d'une invitation valide pour accéder à cette plateforme. Veuillez contacter un membre existant pour obtenir un code d'invitation." :
            "Для доступа к этой платформе вам нужно действительное приглашение. Обратитесь к существующему участнику, чтобы получить код приглашения."
          }
        </p>

        {/* Features List */}
        <div style={{
          background: `${themeVars.border}10`,
          padding: "24px",
          borderRadius: "16px",
          marginBottom: "32px",
          border: `1px solid ${themeVars.border}20`
        }}>
          <h3 style={{
            fontSize: "18px",
            fontWeight: 600,
            marginBottom: "16px",
            color: themeVars.fg
          }}>
            {lang === "en" ? "Why do we use invitations?" : 
             lang === "fr" ? "Pourquoi utilisons-nous des invitations ?" : 
             "Зачем мы используем приглашения?"}
          </h3>
          
          <div style={{
            display: "grid",
            gap: "12px",
            textAlign: "left",
            fontSize: "14px",
            opacity: 0.8
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontSize: "16px" }}>🛡️</span>
              {lang === "en" ? "Maintain a secure and trusted community" : 
               lang === "fr" ? "Maintenir une communauté sécurisée et de confiance" : 
               "Поддерживаем безопасное и надежное сообщество"}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontSize: "16px" }}>👥</span>
              {lang === "en" ? "Ensure quality connections and networking" : 
               lang === "fr" ? "Assurer des connexions et un réseautage de qualité" : 
               "Обеспечиваем качественные связи и нетворкинг"}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontSize: "16px" }}>🎯</span>
              {lang === "en" ? "Keep the platform focused and professional" : 
               lang === "fr" ? "Garder la plateforme concentrée et professionnelle" : 
               "Сохраняем фокус и профессионализм платформы"}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{
          display: "flex",
          gap: "16px",
          justifyContent: "center",
          flexWrap: "wrap"
        }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: themeVars.btnBg,
              color: themeVars.btnFg,
              border: "none",
              borderRadius: "16px",
              padding: "16px 32px",
              fontSize: "16px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 8px 25px #667eea40";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "none";
            }}
          >
            <span style={{ fontSize: "18px" }}>🏠</span>
            {lang === "en" ? "Back to Home" : 
             lang === "fr" ? "Retour à l'accueil" : 
             "На главную"}
          </button>

          <button
            onClick={() => window.location.href = 'mailto:support@createfamily.com?subject=Invitation Request'}
            style={{
              background: "none",
              color: themeVars.fg,
              border: `2px solid ${themeVars.border}`,
              borderRadius: "16px",
              padding: "14px 28px",
              fontSize: "16px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
            onMouseEnter={(e) => {
              e.target.style.background = `${themeVars.border}20`;
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "none";
              e.target.style.transform = "translateY(0)";
            }}
          >
            <span style={{ fontSize: "18px" }}>📧</span>
            {lang === "en" ? "Contact Support" : 
             lang === "fr" ? "Contacter le support" : 
             "Связаться с поддержкой"}
          </button>
        </div>

        {/* Additional Info */}
        <div style={{
          marginTop: "32px",
          padding: "16px",
          background: `${themeVars.border}05`,
          borderRadius: "12px",
          fontSize: "12px",
          opacity: 0.7,
          lineHeight: 1.5
        }}>
          {lang === "en" ? 
            "If you believe you should have access or need help getting an invitation, please contact our support team. We're here to help!" :
           lang === "fr" ? 
            "Si vous pensez que vous devriez avoir accès ou avez besoin d'aide pour obtenir une invitation, veuillez contacter notre équipe de support. Nous sommes là pour vous aider !" :
            "Если вы считаете, что должны иметь доступ, или вам нужна помощь с получением приглашения, свяжитесь с нашей службой поддержки. Мы готовы помочь!"
          }
        </div>
      </div>
    </div>
  );
};

export default InviteErrorPage;




